import React from 'react';
import PrivacyPolicy from './PrivacyPolicy';
import ContactSection from './ContactSection';
import Footer from './Footer';

const Contact = () => {
  return (
    <>
      <PrivacyPolicy />
      <ContactSection />
      <Footer />
    </>
  );
};

export default Contact;
